export default "__VITE_ASSET__DMsMW$yg__"